import React from 'react'
import "./researchText.scss"
import '../../../styles/fontSizes.scss'

// flechas del tipo ^ = type en 1 , v = type en 0
const ResearchText = ({title,text}) =>{
    return(
        <>
            <div className={`research-text__container font-size--2`}>
                <h1 className="research-text__title">{title}</h1>
                <p className="research-text__paragraph">{text}</p>
            </div>
        </>
    )
}

export default ResearchText;